import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=397e2ae6&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=397e2ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e2ae6",
  null
  
)

export default component.exports